<template>
  <div id="customer-support">
    <ul class="customer-ul">
      <li
        v-if="accountStore.operationalManager"
        class="is-opened"
        @click="modalVisibleOps"
      >
        <div class="avatar">
          <img
            v-if="accountStore.operationalManager.mainPicture"
            :src="accountStore.operationalManager.mainPicture.format.small"
            title="operational manager"
          >
        </div>
        <div class="info">
          <div
            v-if="accountStore.operationalManager.firstName && accountStore.operationalManager.lastName"
            class="name"
          >
            {{ accountStore.operationalManager.firstName }} {{ accountStore.operationalManager.lastName }}
          </div>
          <div v-if="accountStore.operationalManager.email" class="subtext">
            Votre contact opérationnel
          </div>
        </div>
      </li>
      <Modal :modal-visible="opsModalVisible" @close-custom-modal="closeOpsModal">
        <template #container>
          <ModalContactOps/>
        </template>
      </Modal>
      <li
        v-if="accountStore.salesManager"
        class="is-opened"
        @click="modalVisibleCom"
      >
        <div class="avatar">
          <img
            v-if="accountStore.salesManager.mainPicture"
            :src="accountStore.salesManager.mainPicture.format.small"
            title="sales manager"
          >
        </div>
        <div class="info">
          <div
            v-if="accountStore.salesManager.firstName && accountStore.salesManager.lastName"
            class="name"
          >
            {{ accountStore.salesManager.firstName }} {{ accountStore.salesManager.lastName }}
          </div>
          <div v-if="accountStore.salesManager.email" class="subtext">
            Votre contact commercial
          </div>
        </div>
      </li>
      <Modal :modal-visible="comModalVisible" @close-custom-modal="closeComModal">
        <template #container>
          <ModalContactCom/>
        </template>
      </Modal>
      <li>
        <div class="avatar">
          <i class="fa fa-phone" aria-hidden="true"/>
        </div>
        <div class="info">
          <div class="name">Numéro d’urgence</div>
          <div class="subtext">
            <a href="tel:0186950215">01 86 95 02 15</a>
          </div>
        </div>
      </li>
      <li>
        <div class="avatar">
          <i class="fa fa-question" aria-hidden="true"/>
        </div>
        <div class="info">
          <div class="name">Aide</div>
          <div class="subtext">
            <a href="https://help-client.studentpop.fr/" target="_blank">Questions Fréquentes</a>
          </div>
        </div>
      </li>
      <li v-if="links && Object.keys(links).length !== 0">
        <div class="avatar">
          <i class="fa fa-link" aria-hidden="true"/>
        </div>
        <div class="info">
          <div class="name">Liens utiles</div>
          <div class="subtext">
            <ul class="link">
              <li v-for="(link, idx) in links" :key="idx"><a
                :href="link.url"
                target="_blank"
                @click="mxTrack"
              >{{ parseType(link.type) }}</a></li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
    <ul class="link-menu">
      <li>© {{ new Date().getFullYear() }} {{ $brand.label }}</li>
      <li><a target="_blank" href="https://www.studentpop.fr/politique-cookie">Politique cookie</a></li>
      <li><a target="_blank" :href="$brand.url.cgu">CGU</a></li>
      <li><a target="_blank" href="https://www.studentpop.fr/politique-confidentialite">Confidentialité</a></li>
    </ul>
  </div>
</template>

<script>

import Modal from '@/components/Global/Modal';
import ModalContactOps from '@/components/Global/ModalContactOps';
import ModalContactCom from '@/components/Global/ModalContactCom';
import { mapStores } from 'pinia';
import { useAccountStore } from '@/stores/account';

export default {
  name: 'customer_support_block',
  components: {
    Modal,
    ModalContactOps,
    ModalContactCom,
  },
  data() {
    return {
      opsModalVisible: false,
      comModalVisible: false,
    };
  },
  computed: {
    ...mapStores(useAccountStore),
    links() {
      return this.accountStore.links;
    },
  },
  methods: {
    parseType(data) {
      switch (data) {
        case 'picture':
          return 'Photos mission';
        case 'import':
          return 'Tableau de commandes';
        case 'reporting':
          return 'Rapport d’animation';
        default:
          break;
      }
      return data;
    },

    mxTrack() {
      this.$mixpanel.track('Side Bar Links Clicked');
    },
    modalVisibleOps() {
      this.$mixpanel.track('Side Bar Ops Clicked');
      this.opsModalVisible = true;
    },
    modalVisibleCom() {
      this.$mixpanel.track('Side Bar Sales Clicked');
      this.comModalVisible = true;
    },
    closeOpsModal() {
      this.opsModalVisible = false;
    },
    closeComModal() {
      this.comModalVisible = false;
    },
  },
};
</script>
